import { Component, Injectable } from '@angular/core';
import { ChooseEnvironmentModalComponent } from '../modals/choose-environment-modal/choose-environment-modal.component';
import { StudyInstanceItem } from '../study-instances-table-selector/study-instances-table-selector.component';
import { StudyInstanceService } from '../../../shared/study/service/study-instance.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChooseDatasetModalComponent } from '../modals/choose-dataset-modal/choose-dataset-modal.component';
import { DatasetModel } from '../../../shared/dataset/model/dataset.model';
import { StudyEditorContext } from '../../study-editor.context';
import { AdvanceStudyModalComponent } from '../../../study-manager/advance/advance-study-modal/advance-study-modal.component';
import { AdvanceType } from '../../../study-manager/advance/abstract-advance.component';
import { AdvanceSamplesModalComponent } from '../../../study-manager/advance/advance-samples-modal/advance-samples-modal.component';
import { ExperimentalDesignTypeEnum } from '../../../shared/experimental.design/experimental-design-type.enum';

@Injectable({
    providedIn: 'root'
})
export class AdvanceStudyModalService {

    constructor(private studyEditorContext: StudyEditorContext,
                private studyInstanceService: StudyInstanceService,
                private modalService: NgbModal) { }

    advanceStudy() {
        this.openSelectDatasetModal();
    }

    advanceSampledPlants() {
        this.openSelectEnvironmentToGenerateModal(null, AdvanceType.SAMPLES);
    }

    private openSelectDatasetModal() {
        const chooseDatasetModalRef = this.modalService.open(ChooseDatasetModalComponent as Component, { size: 'sm', backdrop: 'static' });
        chooseDatasetModalRef.componentInstance.titleKey = 'study-editor.advance-study.choose-dataset.modal-title';
        chooseDatasetModalRef.componentInstance.descriptionKey = 'study-editor.advance-study.choose-dataset.description';
        chooseDatasetModalRef.componentInstance.supportedDatasetTypes = [];
        chooseDatasetModalRef.result.then((datasetModel: DatasetModel) => {
            this.openSelectEnvironmentToGenerateModal(datasetModel, AdvanceType.STUDY);
        });
    }

    private openSelectEnvironmentToGenerateModal(datasetModel: DatasetModel, advanceType: AdvanceType) {
        this.studyInstanceService.listStudyInstances(this.studyEditorContext.studyId).toPromise().then((instances) => {
            const chooseEnvironmentModal = this.modalService.open(ChooseEnvironmentModalComponent as Component, { size: 'md', backdrop: 'static' });
            chooseEnvironmentModal.componentInstance.studyInstanceItems = instances.filter(item => item.hasExperimentalDesign);
            chooseEnvironmentModal.componentInstance.titleKey = (AdvanceType.STUDY === advanceType) ? 'study-editor.advance-study.choose-environment.title' : 'study-editor.advance-sample.choose-environment.title';
            chooseEnvironmentModal.componentInstance.headerKey = 'study-editor.experiment-design.choose-environment.header';
            chooseEnvironmentModal.componentInstance.descriptionKey =  (AdvanceType.STUDY === advanceType) ? 'study-editor.advance-study.choose-environment.description' : 'study-editor.advance-sample.choose-environment.description';
            chooseEnvironmentModal.componentInstance.cancelLabelKey = 'back';
            chooseEnvironmentModal.componentInstance.continueLabelKey = 'continue';
            chooseEnvironmentModal.componentInstance.continueBehavior = 'close_immediately';
            chooseEnvironmentModal.result.then((studyInstanceItems: StudyInstanceItem[]) => {
                if (AdvanceType.STUDY === advanceType && datasetModel) {
                    this.openAdvanceStudyModal(datasetModel, studyInstanceItems);
                } else {
                    this.openAdvanceSampleModal(studyInstanceItems);
                }
            }, (reason: string) => {
                if (reason === 'back') {
                    if (AdvanceType.STUDY === advanceType) {
                        this.openSelectDatasetModal();
                    }
                }
            });
        });
    };

    private openAdvanceStudyModal(datasetModel: DatasetModel, studyInstanceItems: StudyInstanceItem[]) {
        const advanceStudyModalRef  = this.modalService.open(AdvanceStudyModalComponent as Component, { size: 'xl', backdrop: 'static' });
        advanceStudyModalRef.componentInstance.studyId = this.studyEditorContext.studyId;
        advanceStudyModalRef.componentInstance.selectedInstances = studyInstanceItems.map(item => item.instanceNumber.toString());
        // numberOfReplicates in PREP is used to indicate the number of times the test entries will be replicated, set to null for this context
        advanceStudyModalRef.componentInstance.replicationNumber = ExperimentalDesignTypeEnum.P_REP.termId.toString() !== this.studyEditorContext.studyDetails.experimentalDesignDetail?.experimentalDesign?.value ?
            this.studyEditorContext.studyDetails.experimentalDesignDetail?.numberOfReplicates?.value || null : null;
        advanceStudyModalRef.componentInstance.selectedDatasetId = datasetModel.datasetId;
        advanceStudyModalRef.result.then((res) => {

        }, (reason: string) => {
            if (reason === 'back') {
                this.openSelectEnvironmentToGenerateModal(datasetModel, AdvanceType.STUDY);
            }
        });

    }

    private openAdvanceSampleModal(studyInstanceItems: StudyInstanceItem[]) {
        const advanceSamplesModalRef  = this.modalService.open(AdvanceSamplesModalComponent as Component, { size: 'xl', backdrop: 'static' });
        advanceSamplesModalRef.componentInstance.studyId = this.studyEditorContext.studyId;
        advanceSamplesModalRef.componentInstance.selectedInstances = studyInstanceItems.map(item => item.instanceNumber.toString());
        // numberOfReplicates in PREP is used to indicate the number of times the test entries will be replicated, set to null for this context
        advanceSamplesModalRef.componentInstance.replicationNumber = ExperimentalDesignTypeEnum.P_REP.termId.toString() !== this.studyEditorContext.studyDetails.experimentalDesignDetail?.experimentalDesign?.value ?
            this.studyEditorContext.studyDetails.experimentalDesignDetail?.numberOfReplicates?.value || null : null;
        advanceSamplesModalRef.result.then((res) => {
        }, (reason: string) => {
            if (reason === 'back') {
                this.openSelectEnvironmentToGenerateModal(null, AdvanceType.SAMPLES);
            }
        });
    }
}
